var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 69,
    viewBox: "0 0 100 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop/error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.6,
    d: "M90.8384 68.3063C85.2528 68.3063 9.73692 68.1309 9.73692 68.1212C9.70563 68.0424 0.150575 55.4293 12.1824 42.2421C18.1442 35.708 6.70757 27.2428 12.1824 19.9744C21.5607 7.52402 30.8398 14.5359 38.5698 11.0342C39.9358 10.416 41.3063 9.42141 42.6783 7.89465C43.4506 7.03607 44.2968 6.28547 45.203 5.63718C45.342 5.53732 45.4823 5.43989 45.624 5.3453C46.1664 4.98279 46.7291 4.6552 47.3085 4.36048C47.6978 4.16278 48.094 3.98011 48.498 3.81205C49.1388 3.54534 49.7973 3.31517 50.4697 3.12072C51.4249 2.84427 52.4079 2.63846 53.4105 2.49922C53.8477 2.43792 54.2887 2.39002 54.7331 2.35389C63.3708 1.65444 73.0909 5.58806 78.1074 11.3375C79.1172 12.4952 83.7096 18.4854 80.0897 26.7192C77.804 31.9177 87.3794 36.8824 90.7819 42.819C99.4327 57.9117 90.9168 68.1094 90.8381 68.3063H90.8384Z",
    fill: "#D59DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7095 68.1647H22.64C22.9575 67.9019 22.4199 67.3052 21.8584 67.2654C21.6144 67.2472 21.3056 67.2973 20.9531 67.3695C20.8714 66.3132 20.4056 61.5645 18.6492 61.7556C16.6745 61.9695 18.6492 63.8467 19.2072 64.9582C19.6211 65.7813 20.0571 66.9622 20.2561 67.5197C20.0956 67.5532 19.9299 67.5868 19.76 67.6169C19.4985 66.8337 18.5243 64.1994 17.2857 64.3529C15.8316 64.5327 16.4159 65.589 17.4468 66.2159C18.2027 66.6772 19.1313 67.3325 19.5726 67.6488C19.1991 67.7085 18.8086 67.7484 18.4128 67.7393C17.3971 67.7159 16.901 68.0072 16.709 68.1642L16.7095 68.1647Z",
    fill: "#005E3F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M87.4997 67.9466H82.8978C82.6511 67.7389 83.0685 67.2673 83.5044 67.2354C83.6936 67.2213 83.9331 67.2605 84.2066 67.3177C84.27 66.4825 84.6314 62.7284 85.9944 62.8794C87.527 63.0484 85.9944 64.5328 85.5613 65.4116C85.2405 66.0623 84.902 66.9957 84.747 67.4363C84.8713 67.4629 85.0001 67.4891 85.1317 67.5133C85.3351 66.894 86.0904 64.8112 87.0516 64.9327C88.18 65.0751 87.7265 65.9098 86.9267 66.4055C86.3401 66.7701 85.6194 67.2881 85.277 67.5384C85.5672 67.5854 85.87 67.6174 86.1767 67.6101C86.9653 67.5917 87.3495 67.8222 87.4987 67.9461L87.4997 67.9466Z",
    fill: "#005E3F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.888497 68.3125H99.116C99.1838 68.3125 99.2389 68.3785 99.2389 68.4598V68.5447C99.2389 68.626 99.1838 68.692 99.116 68.692H0.888497C0.820705 68.692 0.765625 68.626 0.765625 68.5447V68.4598C0.765625 68.3785 0.820705 68.3125 0.888497 68.3125Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M47.6893 37.5446L45.2622 66.1968C45.2622 66.1968 45.0082 67.9335 46.3092 67.9369C48.4485 67.9417 56.9585 67.9369 56.9585 67.9369C56.9585 67.9369 55.3483 67.5752 55.3678 66.7618C55.3907 65.8032 58.2044 37.2734 58.2044 37.2734L47.6893 37.5446Z",
    fill: "#3A6EEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M57.7555 67.4255C57.3347 67.427 49.0963 67.4405 47.0126 67.4139C46.1046 67.4028 45.9451 66.6121 45.9378 66.1009C45.9339 65.8559 45.9656 65.6743 45.9656 65.6743L46.0285 64.9297L46.1895 63.0318L46.3314 61.3547L46.5142 59.1997L46.6678 57.3808L48.3927 37.0211L58.9078 36.75C58.9078 36.75 57.7228 48.6897 56.8846 57.3803C56.7909 58.3486 56.7022 59.2772 56.6198 60.1438C56.5929 60.4208 56.5676 60.6909 56.5422 60.9543C56.4647 61.7764 56.3935 62.5317 56.3316 63.1984C56.2989 63.5499 56.2687 63.8762 56.2418 64.1754C56.135 65.3475 56.0721 66.096 56.0712 66.2384C56.0712 66.3212 56.078 66.3986 56.0916 66.4703C56.2643 67.3834 57.5975 67.4246 57.7555 67.4246V67.4255Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M22.1523 21.9531L28.0646 45.531L28.8741 48.7598L31.6273 59.7414H82.784L72.6351 21.9531H22.1523Z",
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.1513 21.9531L21.332 22.2243L30.5374 60.5615L31.6268 59.7414L22.1513 21.9531Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.5391 60.5623H81.3808L82.7847 59.7422H31.6285L30.5391 60.5623Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M48.3903 67.9453H59.3984V67.4258H48.3903V67.9453Z",
    fill: "#3A6EEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M56.6007 60.5625L56.5437 60.9595L46.1914 63.0361L46.3333 61.3589L46.4011 60.5625H56.6007Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.4,
    d: "M57.7552 67.4288C57.3343 67.4303 49.096 67.4439 47.0123 67.4172C46.1043 67.4061 45.9448 66.6155 45.9375 66.1042L56.241 64.1797C56.1342 65.3518 56.0713 66.1003 56.0703 66.2427C56.0703 66.3255 56.0772 66.4029 56.0908 66.4746C56.2635 67.3877 57.5967 67.4288 57.7547 67.4288H57.7552Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M22.1523 21.9531H72.6351L80.8257 52.3232H29.7675L22.1523 21.9531Z",
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M78.4438 51.0045H31.1765L29.4873 44.3241L28.8339 41.7392L28.5676 40.6852L26.8316 33.8199L26.7414 33.4626L25.8241 29.8334L25.4135 28.21L25.0634 26.8249L24.2422 23.5781H70.8277L71.7293 26.8249L72.1141 28.21L72.5647 29.8334L75.535 40.5308V40.5313L75.7866 41.4376L75.9036 41.8583L77.9547 49.2431L78.4438 51.0045Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M71.7293 26.8254H25.0634L24.2422 23.5781H70.8282L71.7293 26.8254Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M26.1688 25.0463C26.1127 24.8222 26.2498 24.6406 26.4755 24.6406C26.7013 24.6406 26.93 24.8222 26.9861 25.0463C27.0422 25.2705 26.9052 25.4521 26.6794 25.4521C26.4536 25.4521 26.2249 25.2705 26.1688 25.0463Z",
    fill: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M27.5282 25.0463C27.4721 24.8222 27.6091 24.6406 27.8349 24.6406C28.0607 24.6406 28.2894 24.8222 28.3455 25.0463C28.4016 25.2705 28.2645 25.4521 28.0387 25.4521C27.813 25.4521 27.5843 25.2705 27.5282 25.0463Z",
    fill: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M28.9891 25.0463C28.933 24.8222 29.0701 24.6406 29.2958 24.6406C29.5216 24.6406 29.7503 24.8222 29.8064 25.0463C29.8625 25.2705 29.7255 25.4521 29.4997 25.4521C29.2739 25.4521 29.0452 25.2705 28.9891 25.0463Z",
    fill: "#FBFCFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37537"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7372",
    x: 32.1875,
    y: 15.9922,
    width: 41.2535,
    height: 35.6197,
    rx: 7.5,
    fill: "white",
    stroke: "#B756FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M40.3469 57.8716L41.3625 52.4199L46.9384 52.482L40.3469 57.8716Z",
    fill: "white",
    stroke: "#B756FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M41.6276 51.1632L48.3971 51.3585L40.0969 58.1451L41.6276 51.1632Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 37562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M62.6711 33.8049C62.6711 34.1938 62.6481 34.5773 62.6045 34.954C62.177 38.6417 59.7142 41.7079 56.3692 43.0028C55.2655 43.4292 54.0662 43.6636 52.8123 43.6636C47.3674 43.6636 42.9531 39.2497 42.9531 33.8045C42.9531 28.3592 47.367 23.9453 52.8123 23.9453C58.2576 23.9453 62.6714 28.3592 62.6714 33.8045L62.6711 33.8049Z",
    fill: "#01A324"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M51.754 37.3235C51.3693 37.3235 51.0006 37.1915 50.7284 36.9561L47.6044 34.2549C47.0381 33.7651 47.0381 32.9711 47.6044 32.4814C48.1708 31.9917 49.0891 31.9917 49.6554 32.4814L51.7536 34.2957L55.9716 30.6485C56.5379 30.1588 57.4562 30.1588 58.0225 30.6485C58.5889 31.1382 58.5889 31.9323 58.0225 32.422L54.512 35.4575L52.7789 36.9561C52.5071 37.1911 52.138 37.3235 51.7532 37.3235H51.754Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M71.125 13.7146V6.33594M74.3112 15.4439L81.812 7.47444",
    stroke: "#A020FF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M76.4688 18.4766H83.339",
    stroke: "#A020FF",
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon3);
export default __webpack_public_path__ + "static/media/StepIcon3.e55cd2b5886e349c83aa1c373ea6efda.svg";
export { ForwardRef as ReactComponent };